import React, { Component } from "react";
import {
    Row,
    Col,
    Tooltip,
    Modal,
    Radio,
    Card,
    Collapse,
    Switch,
    Tag,
    message,
    Icon,
    Input,
    Button,
    Spin,
    Typography,
    Dropdown,
    Menu,
    Avatar,
} from "antd";
import axios from "axios";
import moment from "moment";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { UOM } from "constants/UOMConstants";
import {
    handleUpdate,
    handleDelete,
    deleteBanner,
    publishBanner,
    unpublishBanner,
    publishPromo,
    unpublishPromo,
} from "../../../actions/dealsHubAdmin";
import GenericBannerModalContent from "./GenericBannerModalContent";
import "./generic-banner.scss";
import isDev from "../../../server";
import { previewImage } from "antd/lib/upload/utils";
import NullImage from "media/placeholder3.png";
//import {backgroundColor} from "html2canvas/dist/types/css/property-descriptors/background-color";
import ip from "../../../media/information-promotion.png";
import mpt from "../../../media/mpt.png";
import flyer from "../../../media/flyer-promo.png";
import pst from "../../../media/pst.png";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { reoderpromolist } from "utils/apiService";

const { Text } = Typography;
const serverUrl = isDev();
const { Panel } = Collapse;
const { Meta } = Card;
const PromoTypes = [
    {
        key: 0,
        value: "Informational Promotion",
        name:"information"
    },
    {
        key: 1,
        value: "Minimum Purchase Transactional",
        name:"minimum-purchase"
    },
    {
        key: 2,
        value: "Product Specific Transactional",
        name:"product-specific"
    },
    {
        key: 3,
        value: "Flyer",
        name:"flyer"
    },
];
const dateFormat = "DD-MM-YYYY HH:mm:ss";
const antIcon = <Icon type='loading' style={{ fontSize: 24 }} spin />;

const SortableItem = SortableElement(({ handlePromotionClick, promotionObject, index }) => {
    return (
        <Row
            // className='SortableItem'
            display={"flex"}
            style={{
                cursor: "pointer",
                padding: "20px",
                borderBottom: "1px solid #E8E8E8",
                flexDirection: "row",
                background:"#ffffff"
            }}
            onClick={() => {
                handlePromotionClick({ promotionObject, index });
            }}>
            <Col span={1}>
                <Icon type='menu' />
            </Col>
            <Col span={23}>
                <Col span={24}>
                    <Col span={12}>
                        <Col span={4}>
                            <img
                                alt={`${promotionObject.title}'s outer image`}
                                style={{
                                    // height: '62px',
                                    // width: '80px'
                                    width: "100%",
                                }}
                                src={
                                    promotionObject.outer_image?.length > 0
                                        ? promotionObject.outer_image[0].url
                                        : NullImage
                                }
                            />
                        </Col>
                        <Col span={16} style={{ marginLeft: "16px" }}>
                            <Text
                                style={{
                                    color: "#181818",
                                    fontSize: "16px",
                                    display: "block",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}>
                                {promotionObject.title}
                            </Text>
                            <br />
                            {promotionObject.type !== "flyer" ? (
                                <>
                                    {promotionObject.cohort_list?.slice(0, 4)?.map((cohort, index) => (
                                        <Text
                                            key={index}
                                            style={{
                                                padding: "1px 8px 1px 8px",
                                                backgroundColor: "#EAF4EC",
                                                color: "#fec708",
                                                fontSize: "12px",
                                                marginRight: "12px",
                                            }}>
                                            {cohort.name}
                                        </Text>
                                    ))}
                                    <Text style={{ color: "#fec708" }}>
                                        {promotionObject.cohort_list?.length > 4 &&
                                            `+${promotionObject.cohort_list.length - 4} More`}
                                    </Text>
                                </>
                            ) : (
                                <>
                                    {promotionObject.stores?.slice(0, 2)?.map((store, index) => (
                                        <Text
                                            key={index}
                                            style={{
                                                padding: "1px 8px 1px 8px",
                                                backgroundColor: "#EAF4EC",
                                                color: "#fec708",
                                                fontSize: "12px",
                                                marginRight: "12px",
                                            }}>
                                            {store.name}
                                        </Text>
                                    ))}
                                    <Text style={{ color: "#fec708" }}>
                                        {promotionObject.stores?.length > 2 &&
                                            `+${promotionObject.stores.length - 2} More`}
                                    </Text>
                                </>
                            )}
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={10}>
                            {/*<Text>{PromoTypes[promotionObject.promotion_type]?.value}</Text>*/}
                            <img
                                style={{
                                    height: "24px",
                                    width: "24px",
                                    marginRight: "8px",
                                }}
                                alt={""}
                                src={
                                    promotionObject.type === "flyer"
                                        ? flyer 
                                        : promotionObject.type === "information"
                                        ? ip 
                                        : promotionObject.type === "product-specific"
                                        ? pst
                                        : mpt
                                }
                            />
                            <Text
                                style={{
                                    color: "#181818",
                                    fontWeight: "bold",
                                }}>
                                {promotionObject.type === "information"
                                    ? "Informational "
                                    : promotionObject.type === "flyer"
                                    ? "Flyer"
                                    : promotionObject.type === "product-specific"
                                    ? "Product Specific"
                                    : "Minimum Purchase"}
                            </Text>
                        </Col>
                        {/*<Col span={14}>*/}
                        {/*    <span onClick={(e) => e.stopPropagation()}>*/}
                        {/*        <Switch*/}
                        {/*            //onClick={(e)=>e.stopPropogation()}*/}
                        {/*            onChange={(checked) => {*/}
                        {/*                this.togglePublishPromo(checked, this.props.bannerData.uuid, promotionObject.uuid, i);*/}
                        {/*            }}*/}
                        {/*            checked={this.state.toggleStatePromo[i]}*/}
                        {/*        // checked={promotionObject.is_published}*/}
                        {/*        />*/}
                        {/*    </span>*/}

                        {/*</Col>*/}
                    </Col>
                </Col>
                <Col span={24} style={{ marginTop: "20px" }}>
                    <Col span={5}>
                        <Text style={{ fontSize: "12px" }}>Start Date</Text>
                        <br />
                        <Text className='table-listings-value-dark'>
                            {promotionObject.start_time === null
                                ? "-"
                                : moment.parseZone(promotionObject.start_time).format("DD/MM/YYYY HH:mm")}
                        </Text>
                    </Col>
                    <Col span={5}>
                        <Text style={{ fontSize: "12px" }}>End Date</Text>
                        <br />
                        <Text className='table-listings-value-dark'>
                            {promotionObject.end_time === null
                                ? "-"
                                : moment.parseZone(promotionObject.end_time).format("DD/MM/YYYY HH:mm")}
                        </Text>
                    </Col>
                    {promotionObject.type !== "flyer" && promotionObject.type !== "information" && (
                        <>
                            <Col span={5}>
                                <Text style={{ fontSize: "12px" }}>Promo Cost</Text>
                                <br />
                                <Text className='table-listings-value-dark'>
                                    {promotionObject.cost}
                                    {" Points"}
                                </Text>
                            </Col>
                            <Col span={5}>
                                <Text style={{ fontSize: "12px" }}>
                                    {promotionObject.type === "product-specific" ? "Final Amount" : "Promo Amount"}
                                </Text>
                                <br />
                                <Text className='table-listings-value-dark'>
                                    {`${promotionObject.amount} ${
                                        JSON.parse(localStorage.getItem("countryData"))?.currency
                                    }`}
                                </Text>
                            </Col>
                        </>
                    )}
                </Col>
            </Col>
        </Row>
    );
});


const SortableList = SortableContainer(({ bannerData, handlePromotionClick }) => {
    return (
        <div>
            {bannerData.promo_list.map((item, index) => (
                // <Text>Hii</Text>
                <SortableItem
                    className='SortableItemList'
                    key={item.uuid}
                    index={index}
                    promotionObject={item}
                    handlePromotionClick={handlePromotionClick}
                />
            ))}
        </div>
    );
});

class GenericBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleStatePromo: [],
            promoType: "",
            serverUrl: serverUrl,
            previewVisible: false,
            //genericModalVisible: false,
            // fileList: [],
            previewImage: "",
            uploadingInProgress: false, //mutex to prevent duplicate requests during handleChange function of AntD Upload Component
            isSectionDeleteOn: false,
            modalFileUid: "",
            modalFileHttpLink: "",
            spinnerLoading: false,
            saveNameLoading: false,
            promoClicked: null,
            isToggleSectionNameEditable: false,
            createPromoState: false,
            activeIndex: null,
            toggleStateIndex: null,
            isFormCLoseOn: false,
            isPromoTypeSelected: false,
        };
    }

    reorderpromo = ({ promotion_list2 }) => {
        this.props.fetchSortedSection({ promotion_list2: promotion_list2, index: this.props.bannerIndex });
        reoderpromolist({
            requestData: {
                section_data: promotion_list2.map((item) => ({ uuid: item.uuid, type: item.type === "flyer" ? "flyer": "promotion" }))
            },
            resCallback: () => {},
            res200Callback: () => {
                message.success("Order Sorted!");
            },
        });
    };

    componentDidMount = () => {
        document.addEventListener("click", this.handleClickOutside, true);

        this.setState(
            {
                toggleState: this.props.bannerData.is_published,
                toggleStatePromo: this.props.bannerData.promo_list.map((item) => item.is_published),
                spinnerLoading: true,
            },
            () => {
                // console.log("generic banner comp did mount\t", this.state.toggleStatePromo);
                this.setState({
                    spinnerLoading: false,
                });
            }
        );
    };

    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside, true);
    }

    handleClickOutside = (event) => {
        const domNode = ReactDOM.findDOMNode(this);
        if (this.state.isToggleSectionNameEditable) {
            if (!domNode || !domNode.contains(event.target)) {
                this.saveBannerName(event);
            }
        }
    };

    getNewPromoObj = () => {
        return {
            uuid: "",
            title: "",
            type: "",
            description: "",
            cost: 0,
            amount: 0,
            cohort_list: [],
            inner_image: [],
            is_published: false,
            outer_image: [],
            section_uuid: this.props.bannerData.uuid,
            start_time: null,
            end_time: null,
            item_code: "0",
            trigger_amount: 0,
            uom: "0",
            isBuffer: true,
            date_created: "",
        };
    };

    addPromo = () => {
        this.setState(
            {
                previewVisible: true,
                promoClicked: this.getNewPromoObj(),
                toggleStatePromo: [...this.state.toggleStatePromo, false],
            },
            () => {
            }
        );
    };

    removeBufferToggleState = () => {
        let temp = this.state.toggleStatePromo;

        temp.splice(-1, 1);


        this.setState({
            toggleStatePromo: temp,
        });
    };

    togglePublishBanner = (checked) => {
        !checked ? this.unpublishBannerBtn() : this.publishBannerBtn();
    };

    togglePublishPromo = (checked, bannerUuid, promoUuid, i) => {
        !checked ? this.unpublishPromoBtn(bannerUuid, promoUuid, i) : this.publishPromoBtn(bannerUuid, promoUuid, i);
    };

    toggleSectionNameEditable = () => {
        this.setState({
            isToggleSectionNameEditable: !this.state.isToggleSectionNameEditable,
        });
    };

    genExtra = (str) => {
        return (
            <>
                <Tag color={str[1]}>{str[0]}</Tag>
                <Switch
                    checked={this.state.toggleState}
                    onChange={(checked) => {
                        this.togglePublishBanner(checked);
                    }}
                    style={{ marginRight: "10px" }}
                />
            </>
        );
    };

    // handleCancel = (promotionObject) => {
    //     console.log(promotionObject);
    //     if (promotionObject.uuid === "") {
    //         console.log("handle cancel GB");
    //         this.removeBufferToggleState();
    //     }

    //     this.setState({
    //         previewVisible: false
    //     });
    // }

    updateNewDataInParent = (updatedData) => {
        this.setState(
            {
                promoClicked: updatedData,
            },
            () => {
            }
        );
    };

    promoTypeSelected = () => {
        this.setState({
            isPromoTypeSelected: true,
        });
    };

    convertDateBeforeSending = (dateString) => {
        return dateString && dateString.indexOf("Z") === -1 ? dateString.replace(" ", "T").concat("Z") : dateString;
    };

    compareOldAndNewData = (oldData, newData) => {

        if (newData.type === "flyer" && oldData.type === "flyer") {
            return oldData.description === newData.description &&
                JSON.stringify(oldData.stores) === JSON.stringify(newData.stores) &&
                oldData.end_time === newData.end_time &&
                oldData.start_time === newData.start_time &&
                oldData.title === newData.title
                ? true
                : false;
        } else {
            return oldData.amount === newData.amount &&
                JSON.stringify(oldData.cohort_list) === JSON.stringify(newData.cohort_list) &&
                oldData.cost === newData.cost &&
                oldData.description === newData.description &&
                oldData.end_time === newData.end_time &&
                oldData.item_code === newData.item_code &&
                oldData.start_time === newData.start_time &&
                oldData.title === newData.title &&
                oldData.trigger_amount === newData.trigger_amount &&
                oldData.uom === newData.uom
                ? true
                : false;
        }
    };

    handleCancel = () => {

        if (this.state.promoClicked.uuid === "" && !this.state.isPromoTypeSelected) {
            this.discardChanges();
        } else if (this.state.promoClicked.uuid === "" && this.state.isPromoTypeSelected) {
            this.openDiscardConfirmationModal();
        } else if (this.state.promoClicked.uuid !== "") {
            let temp = this.props.bannerData,
                temp2 = null;

            for (let index in temp.promo_list) {
                if (temp.promo_list[index].uuid === this.state.promoClicked.uuid) {
                    temp2 = this.props.bannerData.promo_list[index];
                    temp2["start_time"] = this.convertDateBeforeSending(temp2["start_time"]);
                    temp2["end_time"] = this.convertDateBeforeSending(temp2["end_time"]);
                    break;
                }
            }
            let isDataSame = this.compareOldAndNewData(temp2, this.state.promoClicked);
            isDataSame ? this.discardChanges() : this.openDiscardConfirmationModal();
        }
    };

    openDiscardConfirmationModal = () => this.setState({ isFormCLoseOn: true });

    closeDiscardConfirmationModal = () => this.setState({ isFormCLoseOn: false });

    discardChanges = () =>{
        this.setState({
            previewVisible: false,
            isFormCLoseOn: false,
            promoClicked: null,
            isPromoTypeSelected: false,
        });
        this.props.fetchInitialData();
    }

    handleDelete = (promoData) => {
        if (promoData.uuid === "") {
            this.setState({
                previewVisible: false,
            });
        } else {
            this.setState(
                {
                    spinnerLoading: true,
                },
                () => {
                    axios
                        .post(
                            `${serverUrl}/${
                                JSON.parse(localStorage.getItem("countryData")).database_identifier
                            }/promotion/delete-promotion/`,
                            {
                                uuid: promoData.uuid,
                                permission_category:["STORE_CONTROL_CENTER"]
                            },
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `JWT ${localStorage.getItem("token")}`,
                                },
                            }
                        )
                        .then((response) => {
                            if (response.data.status === 200) {
                                let temp = this.props.bannerData;
                                let tempToggleStatePromo = this.state.toggleStatePromo;
                                for (let index in temp.promo_list) {
                                    if (temp.promo_list[index].uuid === promoData.uuid) {
                                        temp.promo_list.splice(index, 1);
                                        tempToggleStatePromo.splice(index, 1);
                                        break;
                                    }
                                }
                                this.setState(
                                    {
                                        previewVisible: false,
                                        spinnerLoading: false,
                                        toggleStatePromo: tempToggleStatePromo,
                                    },
                                    () => {
                                        // this.props.bannerPromoUpdation({
                                        //     section_uuid: this.props.bannerData.uuid,
                                        //     promoObj: this.getUpdatedPromoObj()
                                        // });
                                    }
                                );
                                this.props.fetchInitialData();
                                message.success("Promo Deleted Successfully!");
                            } else if (response.data.status === 405) {
                                message.info("You are not authorised!");
                            } else {
                                message.error("Something went Wrong!");
                            }
                        });
                }
            );
        }
    };

    handleclosemodal = () =>{
        this.setState({
            previewVisible: false,
        })
    }

    handleFlyerDelete = (promoData) => {
        if (promoData.uuid === "") {
            this.setState({
                previewVisible: false,
            });
        } else {
            this.setState(
                {
                    spinnerLoading: true,
                },
                () => {
                    axios
                        .post(
                            `${serverUrl}/${
                                JSON.parse(localStorage.getItem("countryData")).database_identifier
                            }/flyer/delete-flyer/`,
                            {
                                uuid: promoData.uuid,
                                permission_category:["STORE_CONTROL_CENTER"]
                            },
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `JWT ${localStorage.getItem("token")}`,
                                },
                            }
                        )
                        .then((response) => {
                            if (response.data.status === 200) {
                                let temp = this.props.bannerData;
                                for (let index in temp.promo_list) {
                                    if (temp.promo_list[index].uuid === promoData.uuid) {
                                        temp.promo_list.splice(index, 1);
                                        break;
                                    }
                                }
                                this.setState(
                                    {
                                        previewVisible: false,
                                        spinnerLoading: false,
                                    },
                                    () => {
                                        // this.props.bannerPromoUpdation({
                                        //     section_uuid: this.props.bannerData.uuid,
                                        //     promoObj: this.getUpdatedPromoObj()
                                        // });
                                    }
                                );
                                message.success("Promo Deleted Successfully!");
                            } else if (response.data.status === 405) {
                                message.info("You are not authorised!");
                            } else {
                                message.error("Something went Wrong!");
                            }
                        });
                }
            );
        }
    };

    deleteBannerBtn = (event) => {
        let tempUuid = event.target.getAttribute("value");
        this.props.deleteBanner(tempUuid.substr(0, tempUuid.indexOf("$")));
        this.props.spinnerOn(true);
    };

    publishPromoBtn = (bannerUuid, promoUuid, i) => {
        this.setState(
            {
                spinnerLoading: true,
            },
            () => {
                axios
                    .post(
                        `${serverUrl}/${
                            JSON.parse(localStorage.getItem("countryData")).database_identifier
                        }/promotion/publish-promotion/`,
                        {
                            uuid: promoUuid,
                            permission_category:["STORE_CONTROL_CENTER"]
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `JWT ${localStorage.getItem("token")}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status === 200) {
                            message.success("Published Successfully!");
                            this.props.publishPromo(bannerUuid, promoUuid);
                            this.setState(
                                {
                                    spinnerLoading: false,
                                    toggleStatePromo: this.state.toggleStatePromo.map((item, index) =>
                                        index === i ? true : item
                                    ),
                                    //toggleState: true
                                },
                                () => {
                                }
                            );
                        } else if (response.data.status === 403) {
                            message.info("You are not authorised!");
                        } else {
                            message.error("Something went wrong!");
                        }
                    });
            }
        );
    };

    publishBannerBtn = () => {
        this.setState(
            {
                spinnerLoading: true,
            },
            () => {
                axios
                    .post(
                        `${serverUrl}/${
                            JSON.parse(localStorage.getItem("countryData")).database_identifier
                        }/section/publish-section/`,
                        {
                            uuid: this.props.bannerData.uuid,
                            permission_category:["STORE_CONTROL_CENTER"]
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `JWT ${localStorage.getItem("token")}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status === 200) {
                            this.props.fetchInitialData();
                            message.success("Published Successfully!");
                            this.props.publishBanner(this.props.bannerData.uuid);
                            this.setState({
                                spinnerLoading: false,
                                toggleState: true,
                            });
                        } else if (response.data.status === 403) {
                            message.info("You are not authorised!");
                        } else {
                            message.error("Something went wrong!");
                        }
                    });
            }
        );
    };

    unpublishPromoBtn = (bannerUuid, promoUuid, i) => {
        this.setState(
            {
                spinnerLoading: true,
            },
            () => {
                axios
                    .post(
                        `${serverUrl}/${
                            JSON.parse(localStorage.getItem("countryData")).database_identifier
                        }/promotion/unpublish-promotion/`,
                        {
                            uuid: promoUuid,
                            permission_category:["STORE_CONTROL_CENTER"]
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `JWT ${localStorage.getItem("token")}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status === 200) {
                            message.success("Unpublished Successfully!");
                            this.props.unpublishPromo(bannerUuid, promoUuid);
                            this.setState(
                                {
                                    spinnerLoading: false,
                                    toggleStatePromo: this.state.toggleStatePromo.map((item, index) =>
                                        index === i ? false : item
                                    ),
                                    // toggleState: false
                                },
                                () => {
                                }
                            );
                        } else if (response.data.status === 403) {
                            message.info("You are not authorised!");
                        } else {
                            message.error("Something went wrong!");
                        }
                    });
            }
        );
    };

    unpublishBannerBtn = () => {
        this.setState(
            {
                spinnerLoading: true,
            },
            () => {
                axios
                    .post(
                        `${serverUrl}/${
                            JSON.parse(localStorage.getItem("countryData")).database_identifier
                        }/section/unpublish-section/`,
                        {
                            uuid: this.props.bannerData.uuid,
                            permission_category:["STORE_CONTROL_CENTER"]
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `JWT ${localStorage.getItem("token")}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status === 200) {
                            this.props.fetchInitialData();
                            message.success("Unpublished Successfully!");
                            // this.props.unpublishBanner(this.props.bannerData.uuid);
                            this.setState({
                                spinnerLoading: false,
                                toggleState: false,
                            });
                        } else if (response.data.status === 403) {
                            message.info("You are not authorised!");
                        } else {
                            message.error("Something went wrong!");
                        }
                    });
            }
        );
    };

    changeCategoryName = (event) => {
        this.props.handleUpdate({
            uuid: this.props.bannerData.uuid,
            value: event.target.value,
        });
    };

    saveBannerName = (e) => {
        e.stopPropagation();
        this.setState(
            {
                saveNameLoading: true,
            },
            () => {
                axios
                    .post(
                        `${this.state.serverUrl}/${
                            JSON.parse(localStorage.getItem("countryData")).database_identifier
                        }/section/update-section/`,
                        {
                            uuid: this.props.bannerData.uuid,
                            name: this.props.bannerData.name,
                            permission_category:["STORE_CONTROL_CENTER"]
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `JWT ${localStorage.getItem("token")}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status === 200) {
                            message.success("Banner name updated Successfully!");
                            this.toggleSectionNameEditable();
                            this.setState({
                                saveNameLoading: false,
                            });
                        } else if (response.data.status === 403) {
                            message.info("You are not authorised!");
                        } else {
                            message.error("Something went wrong!");
                        }
                    });
            }
        );
    };

    SectionRowHeader = (id) => {
        return (
            <Row
                style={{
                    paddingRight: "26px",
                    paddingBottom: "16px",
                    backgroundColor: this.props.bgColor ? "#EAF4EC" : "#FFFFFF",
                    position: "relative",
                    width: "100%",
                }}
                onClick={() => {
                    this.setState({
                        activeIndex: this.state.activeIndex === id ? "null" : id,
                    });
                }}>
                <Col span={7}>
                    {this.state.isToggleSectionNameEditable ? (
                        <Input
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                            style={{
                                fontWeight: "700",
                                fontStyle: "normal",
                                fontSize: "16px",
                                lineHeight: "28.13px",
                                color: "#181818",
                                border: "1px solid #0085FF",
                                borderRadius: "5px",
                                width: "80%",
                            }}
                            // autoFocus
                            defaultValue={this.props.bannerData.name}
                            onChange={(event) => {
                                event.stopPropagation();
                                this.changeCategoryName(event);
                            }}
                            maxLength={100}
                            onPressEnter={(event) => {
                                this.saveBannerName(event);
                            }}
                            suffix={
                                <Icon
                                    onClick={(event) => {
                                        this.saveBannerName(event);
                                    }}
                                    // onClick={this.saveBannerName}
                                    type='check-circle'
                                />
                            }
                        />
                    ) : (
                        <Text
                            onClick={(event) => {
                                event.stopPropagation();
                                this.toggleSectionNameEditable();
                            }}
                            style={{
                                fontWeight: "bold",
                                fontStyle: "normal",
                                fontSize: "16px",
                                lineHeight: "24px",
                                color: "#181818",
                                marginBottom: "0px",
                                marginLeft: "20px",
                                display: "block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}>
                            {this.props.bannerData.name}
                        </Text>
                    )}
                    <br />
                    <Text
                        style={{
                            fontWeight: "bold",
                            color: "#fec708",
                            marginLeft: "20px",
                        }}>
                        {this.props.bannerData.type.name === "Grid"
                            ? `${this.props.bannerData.promo_list.length} Promotions`
                            : `${this.props.bannerData.promo_list.length} Banner Ad`}
                    </Text>
                    <Icon
                        style={{ color: "#fec708", marginLeft: "6px" }}
                        type='down'
                        rotate={this.state.activeIndex === id ? "180" : "0"}
                    />
                </Col>
                <Col span={5}>
                    <Text className='table-listings-value-dark'>{this.props.bannerData.date_created}</Text>
                </Col>
                <Col span={5} style={{ marginLeft: "-8px" }}>
                    <img
                        style={{ height: "24px", width: "24px", borderRadius: "5px" }}
                        src={this.props.bannerData.type.name === "Grid" ? this.props.grid : this.props.banner}
                    />
                    <Text
                        style={{
                            color: "#181818",
                            fontWeight: "bold",
                            marginLeft: "8px",
                        }}>
                        {this.props.bannerData.type.name === "Grid" ? "Grid" : "Banner Ad"}
                    </Text>
                </Col>
                <Col span={7} style={{ marginLeft: "4px" }}>
                    <Row type={"flex"} justify={"space-between"}>
                        <Switch
                            checked={this.state.toggleState}
                            onChange={(checked) => {
                                this.togglePublishBanner(checked);
                            }}
                            style={{}}
                        />
                        {this.props.bannerData.promo_list.length < this.props.bannerData.type.limit ? (
                            <Button
                                style={{
                                    height: "24px",
                                    border: "none",
                                    color: "#fec708",
                                    boxShadow: "none",
                                    backgroundColor: this.props.bgColor ? "#EAF4EC" : "#FFFFFF",
                                    //boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                                    //color: "#fff",
                                }}
                                onClick={(e) => {
                                    // e.stopPropagation();
                                    this.addPromo();
                                }}>
                                <Icon type='plus' style={{ color: "#fec708" }} />
                                Add Promo
                            </Button>
                        ) : (
                            ""
                        )}
                        <Dropdown
                            placement={"bottomLeft"}
                            overlay={
                                <Menu>
                                    <Menu.Item
                                        onClick={(e) => {
                                            this.toggleSectionNameEditable();
                                        }}>
                                        <Text style={{ color: "#181818" }}>Rename</Text>
                                    </Menu.Item>
                                    <Menu.Item onClick={() => this.setState({ isSectionDeleteOn: true })}>
                                        <Text
                                            style={{
                                                color: "#F5222D",
                                            }}>
                                            Delete
                                        </Text>
                                    </Menu.Item>
                                </Menu>
                            }>
                            <Icon
                                type='more'
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                style={{ fontSize: "16px", color: "#747474"}}
                            />
                        </Dropdown>
                    </Row>
                </Col>
            </Row>
        );
    };

    handlePromotionChange = ({ oldIndex, newIndex }) => {
        if (newIndex !== oldIndex) {
            let promotion_list2 = [...this.props.bannerData.promo_list];
            // promotion_list2.sort((a,b)=>{
            //     if (a.order_index > b.order_index) {    
            //         return 1;    
            //     } else if (a.order_index < b) {    
            //         return -1;    
            //     }    
            //     return 0;
            // })

            [promotion_list2[newIndex], promotion_list2[oldIndex]] = [
                promotion_list2[oldIndex],
                promotion_list2[newIndex],
            ];
            promotion_list2[newIndex].order_index = oldIndex+1;
            promotion_list2[oldIndex].order_index = newIndex+1;

            this.reorderpromo({ promotion_list2 });
            // this.props.fetchInitialData();
        }
    };

    handlePromotionClick = ({ promotionObject, i }) => {
        this.setState({
            previewVisible: true,
            promoClicked: promotionObject,
            toggleStateIndex: i,
        });
    };

    render() {
        const { previewVisible, previewImage } = this.state;
        // console.log(this.props.activeIndex, "my index", this.props.bannerIndex)
        if (!this.state.spinnerLoading) {
            return (
                <React.Fragment key={this.props.bannerIndex}>
                    <Collapse
                        expandIcon={() => <Icon type='menu' />}
                        expandIconPosition='left'
                        // accordion={true}
                        // defaultActiveKey={"0"}
                    >
                        <Panel
                            key={this.props.bannerIndex}
                            style={{ backgroundColor: this.props.bgColor ? "#EAF4EC" : "#FFFFFF" }}
                            // header={}
                            extra={this.SectionRowHeader(this.props.bannerIndex)}
                            className='dealshub-admin-collapse-panel'>
                            <div
                                className='content-container'
                                // style={{
                                //     padding: "20px",
                                //     background: "#fff"
                                // }}
                            >
                                <div>
                                    <Row>
                                        <Col span={24}>
                                            {this.state.uploadingInProgress ? (
                                                <div className='dealshub-admin-section-category-deletion-in-progress-container'>
                                                    <Spin indicator={antIcon} tip='Uploading Unit Banner Data' />
                                                </div>
                                            ) : (
                                                <div>
                                                    <Row style={{ margin: "10px 0px" }} gutter={[24, 24]}>
                                                        {this.props.bannerData.promo_list &&
                                                        this.props.bannerData.promo_list.length > 0 ? (
                                                            <SortableList
                                                                bannerData={this.props.bannerData}
                                                                onSortEnd={this.handlePromotionChange}
                                                                handlePromotionClick={this.handlePromotionClick}
                                                                distance={1}
                                                                lockAxis='y'
                                                            />
                                                        ) : (
                                                            <Col span={24}>
                                                                <div
                                                                    style={{
                                                                        textAlign: "center",
                                                                        maxWidth: "500px",
                                                                        margin: "0 auto",
                                                                    }}>
                                                                    <p>
                                                                        No Promo has been added here. Click on the green
                                                                        colour <b>"Add Promo" Button</b> to add a
                                                                        Promotion.
                                                                    </p>
                                                                </div>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                </div>
                                            )}
                                            <Modal
                                                visible={this.state.previewVisible}
                                                footer={null}
                                                // onCancel={() => this.handleCancel()}
                                                onCancel={this.handleCancel}
                                                destroyOnClose
                                                maskClosable={false}
                                                width={"50vw"}
                                                style={{
                                                    backgroundColor: "#fff",
                                                    borderRadius: "10px",
                                                }}
                                                bodyStyle={{
                                                    background: "#fff",
                                                    padding: "15px 20px",
                                                    borderRadius: "10px",
                                                }}
                                                title={PromoTypes[this.state.promoType]?.value}>
                                                <GenericBannerModalContent
                                                    // createPromoState = {this.state.createPromoState}
                                                    // unpublishPromoBtn={this.unpublishPromoBtn}
                                                    // publishPromoBtn={this.publishPromoBtn}
                                                    promoClickedIndex={this.state.toggleStateIndex}
                                                    toggleStateFromParent={
                                                        // this.state.toggleStatePromo[this.state.toggleStateIndex]
                                                        this.props.bannerData.promo_list.find(item=>item.order_index === this.state.toggleStateIndex)
                                                    }
                                                    bannerData={this.props.bannerData}
                                                    promoTypes={PromoTypes}
                                                    bannerPromoData={this.state.promoClicked}
                                                    bannerIndex={this.props.bannerIndex}
                                                    modalFileUid={this.state.modalFileUid}
                                                    modalFileHttpLink={this.state.modalFileHttpLink}
                                                    previewImage={previewImage}
                                                    locationUuid={this.props.locationUuid}
                                                    closePromoModal={this.handleDelete}
                                                    closeFlyerPromoModal={this.handleFlyerDelete}
                                                    uomObject={UOM}
                                                    fetchInitialData={this.props.fetchInitialData}
                                                    updateNewDataInParent={this.updateNewDataInParent}
                                                    promoTypeSelected={this.promoTypeSelected}
                                                    convertDateBeforeSending={this.convertDateBeforeSending}
                                                    handleclosemodal={this.handleclosemodal}
                                                />
                                            </Modal>
                                            <Modal
                                                centered
                                                visible={this.state.isSectionDeleteOn}
                                                footer={null}
                                                onCancel={() => this.setState({ isSectionDeleteOn: false })}
                                                maskClosable={false}
                                                destroyOnClose={true}
                                                style={{
                                                    backgroundColor: "#fff",
                                                    borderRadius: "10px",
                                                    boxShadow: "0px 10px 30px rgba(24, 24, 24, 0.2)",
                                                }}
                                                bodyStyle={{
                                                    background: "#fff",
                                                    borderRadius: "10px",
                                                }}
                                                title={null}>
                                                <Row className='modal-row'>
                                                    <Row>
                                                        <Icon
                                                            type='delete'
                                                            style={{
                                                                color: "#181818",
                                                                fontSize: "24px",
                                                                marginRight: "16px",
                                                            }}
                                                        />
                                                        <Text
                                                            style={{
                                                                fontWeight: "bold",
                                                                color: "#181818",
                                                                fontSize: "24px",
                                                            }}>
                                                            Delete item
                                                        </Text>
                                                    </Row>
                                                    {/*<p>Are you sure you want to delete this Section?</p>*/}
                                                    <Row style={{ marginTop: "24px" }}>
                                                        <Col span={24}>
                                                            <Text>Are you sure you want to delete this Section?</Text>
                                                        </Col>
                                                        <Col
                                                            style={{
                                                                marginTop: "60px",
                                                                textAlign: "right",
                                                            }}
                                                            span={18}>
                                                            <Button
                                                                size='large'
                                                                style={{
                                                                    height: "40px",
                                                                    boxShadow: "none",
                                                                    borderRadius: "20px",
                                                                    border: "none",
                                                                    backgroundColor: "#FFFFFF",
                                                                    color: "#181818",
                                                                }}
                                                                onClick={() =>
                                                                    this.setState({ isSectionDeleteOn: false })
                                                                }>
                                                                Cancel
                                                            </Button>
                                                        </Col>
                                                        <Col
                                                            style={{
                                                                marginTop: "60px",
                                                                textAlign: "right",
                                                            }}
                                                            span={6}>
                                                            <Button
                                                                size='large'
                                                                style={{
                                                                    height: "40px",
                                                                    borderRadius: "5px",
                                                                    border: "none",
                                                                    backgroundColor: "#C91713",
                                                                    color: "#FFFFFF",
                                                                }}
                                                                onClick={() => {
                                                                    this.props.deleteBanner(this.props.bannerData.uuid);
                                                                }}>
                                                                Delete
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Row>
                                            </Modal>
                                            <Modal
                                                visible={this.state.isFormCLoseOn}
                                                footer={null}
                                                onCancel={this.closeDiscardConfirmationModal}
                                                destroyOnClose={true}
                                                maskClosable={false}
                                                style={{
                                                    backgroundColor: "#fff",
                                                    borderRadius: "10px",
                                                    boxShadow: "0px 10px 30px rgba(24, 24, 24, 0.2)",
                                                }}
                                                bodyStyle={{
                                                    background: "#fff",
                                                    borderRadius: "10px",
                                                }}
                                                title={null}>
                                                <Row className={"modal-row"}>
                                                    <Row>
                                                        <Icon
                                                            type='edit'
                                                            style={{
                                                                color: "#181818",
                                                                fontSize: "24px",
                                                                marginRight: "16px",
                                                            }}
                                                        />
                                                        <Text
                                                            style={{
                                                                fontWeight: "bold",
                                                                color: "#181818",
                                                                fontSize: "24px",
                                                            }}>
                                                            Discard draft
                                                        </Text>
                                                    </Row>
                                                    <Row style={{ marginTop: "24px" }}>
                                                        <Col span={24}>
                                                            <Text>
                                                                You haven’t finished the promotion yet. Are you sure you
                                                                want to leave and discard your draft?
                                                            </Text>
                                                        </Col>
                                                        <Col
                                                            style={{
                                                                marginTop: "60px",
                                                                textAlign: "right",
                                                            }}
                                                            span={18}>
                                                            <Button
                                                                size='large'
                                                                style={{
                                                                    height: "40px",
                                                                    borderRadius: "5px",
                                                                    border: "1px solid #fec708",
                                                                    backgroundColor: "#FFFFFF",
                                                                    color: "#fec708",
                                                                }}
                                                                onClick={this.closeDiscardConfirmationModal}>
                                                                Go Back
                                                            </Button>
                                                        </Col>
                                                        <Col
                                                            style={{
                                                                marginTop: "60px",
                                                                textAlign: "right",
                                                            }}
                                                            span={6}>
                                                            <Button
                                                                size='large'
                                                                style={{
                                                                    height: "40px",
                                                                    borderRadius: "5px",
                                                                    border: "none",
                                                                    backgroundColor: "#fec708",
                                                                    color: "#FFFFFF",
                                                                }}
                                                                onClick={this.discardChanges}>
                                                                Discard
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Row>
                                            </Modal>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>
                </React.Fragment>
            );
        } else {
            return <Spin></Spin>;
        }
    }
}

const mapStateToProps = ({ dealsHubAdmin }) => {
    return {
        dealsHubAdmin,
    };
};

export default connect(mapStateToProps, {
    handleUpdate,
    handleDelete,
    deleteBanner,
    publishBanner,
    unpublishBanner,
    publishPromo,
    unpublishPromo,
})(GenericBanner);
